export default "__VITE_ASSET__PdsmVhMf__"